import { GenSubSubBase } from './base/gen-sub-sub-base';

export class GenSubSub extends GenSubSubBase { }